import { useEffect, useRef, useState } from 'react'

const useCenteredSlides = (containerRef, trayRef) => {
  let [centered, setCentered] = useState(false)

  let handler = useRef()

  handler.current = () => {
    let containerWidth = containerRef.current.offsetWidth
    let trayWidth = trayRef.current.offsetWidth
    setCentered(containerWidth > trayWidth)
  }

  useEffect(() => {
    let container = containerRef.current
    let tray = trayRef.current

    let observer = new ResizeObserver(() => {
      handler.current()
    })

    observer.observe(container)
    observer.observe(tray)

    return () => {
      observer.unobserve(container)
      observer.unobserve(tray)
    }
  }, [containerRef, trayRef])

  return { centered }
}

export default useCenteredSlides
